export enum AppKey {
  ADMIN = 'admin',
  CAPITAL_ACCESS = 'capitalAccess',
  CAPITAL_INSIGHT = 'capitalInsight',
  COMPASS = 'compass',
  CAPITAL_IQ_PRO = 'capitalIqPro',
  CAPITAL_IQ_PRO_SAM = 'capitalIqProSam',
  CAPITAL_IQ_PRO_BASE = 'capitalIqProBase'
}
